@if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-toolbar>
  <mat-icon mat-list-icon>people</mat-icon>
  <span class="container-fluid">
    <h1>
      {{ 'USER_MANAGEMENT.ADD_MEMBERS' | transloco }}
    </h1>
  </span>
</mat-toolbar>

<mat-dialog-content class="mt-3">
  <form [formGroup]="organizationForm" (ngSubmit)="saveChanges()">
    <mat-form-field appearance="outline" class="w-100">

      <!-- Member -->
      <mat-label class="label-margin-left">
        {{ 'USER_MANAGEMENT.MEMBERS' | transloco }}
      </mat-label>

      <mat-select formControlName="member">
        @for (member of membersList; track member) {
          <mat-option [value]="member">
            {{member.firstname}} {{member.lastname}}
            <span class="small-grey-text">
              ( {{ member.email }} )
            </span>
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Membership Type -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label class="label-margin-left">
        {{ 'USER_MANAGEMENT.MEMBERSHIP_TYPE' | transloco }}
      </mat-label>
      <mat-select formControlName="membershipType" multiple>
        @for (type of memberShipTypes; track type) {
          <mat-option [value]="type.id">
            {{type.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" [align]="'end'">
  <button mat-button mat-dialog-close>{{ 'PRICING.FORM.CANCEL' | transloco }}</button>
  <button mat-button mat-raised-button color="primary" type="submit" (click)="saveChanges()">
    {{ 'USER_MANAGEMENT.SAVE_CHANGES' | transloco }}
  </button>
</mat-dialog-actions>
